var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsChevronDownOutlineBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D04A02;}\n\t.st1{fill:#E0301E;}\n\t.st2{fill:#DB536A;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#464646;}\n\t.st5{fill:#7D7D7D;}\n\t.st6{fill:#2D2D2D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-v2_11_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Down-Chevron_9_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_9_",
    d: "M84.2,30.6L52,62.7L19.8,30.6c-0.9-0.9-2.3-0.9-3.2,0c-0.9,0.9-0.9,2.3,0,3.2L52,69.1l35.3-35.3 c0.9-0.9,0.9-2.3,0-3.2C86.5,29.7,85,29.7,84.2,30.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsChevronDownOutlineBrand);
export default __webpack_public_path__ + "static/media/Icons_ChevronDown_Outline_Brand.df6d06cd9a4f93ca9f812fa0d2447dd9.svg";
export { ForwardRef as ReactComponent };